import { TYPOGRAPHY_COLORS } from 'constants/TypographyColors'
import { SVGIcon } from './SvgIcon/SvgIcon'
import { IconProps } from './types'

export const RefreshIcon = ({
  size,
  color = 'grey400',
  className,
  onClick,
  dataTestId,
}: IconProps) => (
  <SVGIcon
    size={size}
    color={color}
    viewBox="0 0 16 16"
    className={className}
    onClick={onClick}
    dataTestId={dataTestId}
  >
    <path
      d="M0.667969 2.66699V6.66699H4.66797"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M15.332 13.333V9.33301H11.332"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M13.6613 6.00038C13.3232 5.0449 12.7485 4.19064 11.991 3.51732C11.2334 2.844 10.3177 2.37355 9.32911 2.14988C8.34056 1.92621 7.31147 1.9566 6.33784 2.23823C5.36422 2.51985 4.4778 3.04352 3.7613 3.76038L0.667969 6.66704M15.3346 9.33371L12.2413 12.2404C11.5248 12.9572 10.6384 13.4809 9.66476 13.7625C8.69114 14.0441 7.66204 14.0745 6.67349 13.8509C5.68495 13.6272 4.76917 13.1568 4.01161 12.4834C3.25406 11.8101 2.67941 10.9559 2.3413 10.0004"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SVGIcon>
)
